// Production diagnostics utility
export const runProductionDiagnostics = () => {
  console.log('🔧 Running Production Diagnostics...');
  
  const diagnostics = {
    timestamp: new Date().toISOString(),
    environment: {
      mode: import.meta.env.MODE,
      dev: import.meta.env.DEV,
      prod: import.meta.env.PROD,
      baseUrl: import.meta.env.BASE_URL,
    },
    supabase: {
      url: import.meta.env.VITE_SUPABASE_URL ? '✅ Present' : '❌ Missing',
      anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ? '✅ Present' : '❌ Missing',
      urlLength: import.meta.env.VITE_SUPABASE_URL?.length || 0,
      keyLength: import.meta.env.VITE_SUPABASE_ANON_KEY?.length || 0,
    },
    browser: {
      userAgent: navigator.userAgent,
      language: navigator.language,
      cookieEnabled: navigator.cookieEnabled,
      onLine: navigator.onLine,
    },
    page: {
      url: window.location.href,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
    },
    localStorage: {
      available: (() => {
        try {
          localStorage.setItem('test', 'test');
          localStorage.removeItem('test');
          return true;
        } catch {
          return false;
        }
      })(),
    },
    errors: (() => {
      try {
        return JSON.parse(localStorage.getItem('app_errors') || '[]');
      } catch {
        return [];
      }
    })(),
  };
  
  console.table(diagnostics.environment);
  console.table(diagnostics.supabase);
  console.table(diagnostics.browser);
  console.log('📊 Full Diagnostics:', diagnostics);
  
  return diagnostics;
};

// Auto-run diagnostics in production
if (import.meta.env.PROD) {
  // Add to global scope for manual debugging
  (window as any).runProductionDiagnostics = runProductionDiagnostics;
  
  // Run immediately
  setTimeout(() => {
    runProductionDiagnostics();
  }, 1000);
}
